/**
 * EL PRODUCTO CON QUE ABRE «COMPRAS FINANCIADAS».
 *
 * Hasta el 28-oct-2026 abría siempre en CREDIT (los créditos de Mundo Total). Con una
 * aseguradora arriba (fase 1 de seguros: MERCANTIL y CARACAS son «Proveedor de servicio»),
 * la pantalla le pedía al núcleo los créditos de MT de esa aseguradora, que son cero, y su
 * tienda (SM o SC) salía siempre en 0 aunque tuviera ventas. Lo reportó Mileidys en staging.
 *
 * La pareja comercio → producto es la misma del re-marcado del histórico en el núcleo
 * (scripts/migracion/marcar_seguros_en_aseguradoras.js: SEGUROS_MERCANTIL→SM→MERCANTIL,
 * SEGUROS_CARACAS→SC→CARACAS). No se lee `insurance.insurer_code` del catálogo: en la base
 * SEGUROS_MERCANTIL lo tiene en «SC», está errado.
 *
 * Con MT, con «todos los comercios» o con cualquier otro comercio: CREDIT, como siempre.
 * Si el producto de la aseguradora no está en el catálogo cargado, también CREDIT.
 */
export const PRODUCTO_DE_ASEGURADORA: { [comercio: string]: string } = {
  MERCANTIL: 'SEGUROS_MERCANTIL',
  CARACAS: 'SEGUROS_CARACAS',
};

export function productoPorOmision(comercio: string | null | undefined, catalogo?: any[] | null): string {
  const codigo = (comercio || '').trim().toUpperCase();
  const producto = PRODUCTO_DE_ASEGURADORA[codigo];
  if (!producto) return 'CREDIT';
  if (Array.isArray(catalogo) && catalogo.length > 0
      && !catalogo.some((p: any) => p?.params?.code === producto)) return 'CREDIT';
  return producto;
}
